export const isCompassFeatureFlagEnabled = (empType: string): boolean => {
    return empType === "I" || localStorage.getItem("admin") === "true";
}